import { Trans, useTranslation } from 'react-i18next';

/** The legal texts a person accepts before creating an account (sculpt-api `content/{en,fr}/legal/`), always the
 *  published ones: what is accepted is what the website shows. */
export const LEGAL_URLS = {
  terms: 'https://sculpt-agent.ai/legal#terms',
  dpa: 'https://sculpt-agent.ai/legal#dpa',
  privacy: 'https://sculpt-agent.ai/legal#privacy',
} as const;

function legalLink(href: string) {
  // Opened in the system browser, like the "forgot password" link.
  return <a href={href} target="_blank" rel="noopener noreferrer" className="text-accent underline hover:text-accent-dark" />;
}

const LINKS = { terms: legalLink(LEGAL_URLS.terms), dpa: legalLink(LEGAL_URLS.dpa), privacy: legalLink(LEGAL_URLS.privacy) };

/** "By continuing, you accept the Terms of sale, including the Data Processing Agreement. See our Privacy policy."
 *  Above the buttons that create an account: a first Microsoft sign-in, and the portal's signup. What makes the
 *  Terms (and the DPA they include) binding; the acceptance date is the account's `created_at` (sculpt-api review
 *  DEC-05). */
export function LegalMention() {
  const { t } = useTranslation();
  return (
    <p className="text-[12px] leading-[1.5] text-ink" data-testid="legal-mention">
      <Trans t={t} i18nKey="legal.mention" components={LINKS} />
    </p>
  );
}
